import { Button } from "primereact/button";
import { useForm } from "react-hook-form";
import { JVDropdown } from "../../../shared/JVDropdown";
import { yupResolver } from "@hookform/resolvers/yup";
import { ITenderMast } from "./Tender_Mast";
import * as yup from "yup";
import { Dialog } from "primereact/dialog";
import { Fetch } from "../../../shared/Fetch";
import { useEffect, useState } from "react";
interface Props {
  openAssigned: {
    open: boolean;
    singleData: ITenderMast;
  };
  onHide: () => void;
  toast: any;
  loadTableData: () => void;
}
const TenderAssigned = ({ openAssigned, onHide, toast, loadTableData }: Props) => {
  const [proposalWriter, setProposalWriter] = useState([]);
  const {
    control,
    handleSubmit,
    formState: { errors },
    reset,
  } = useForm<{ AssignedTo: number }>({
    resolver: yupResolver(yup.object({ AssignedTo: yup.number().moreThan(0, "Assignee is required").required("Assignee is required") })),
    defaultValues: { AssignedTo: 0 },
    shouldFocusError: false,
  });
  const loadProposalWriter = async () => {
    const response = await Fetch("Tender_Mast/GetProposalWriterUser", "GET", null, null, toast);
    if (response) {
      const data = await response.json();
      setProposalWriter(data);
    }
  };
  useEffect(() => {
    loadProposalWriter();
  }, []);

  const onSave = async (data: { AssignedTo: number }) => {
    const response = await Fetch(
      "Tender_Mast/assign",
      "POST",
      {
        tenderId: openAssigned.singleData.id,
        assignedTo: data.AssignedTo,
      },
      null,
      toast,
    );

    if (response?.ok) {
      toast.current.show({ severity: "success", summary: "Success", detail: "Task assigned successfully" });
      loadTableData();
      onHide();
    }
  };

  useEffect(() => {
    if (openAssigned.open) {
      reset({ AssignedTo: openAssigned.singleData.assignedToId ?? 0 });
    }
  }, [openAssigned.open, openAssigned.singleData, reset]);

  return (
    <>
      <Dialog visible={openAssigned.open} modal header="Assign Task" style={{ width: "80vw" }} onHide={onHide}>
        <form onSubmit={handleSubmit(onSave)}>
          <div className="p-fluid formgrid grid">
            <JVDropdown required column={3} label="Assigned To" control={control} name="AssignedTo" options={proposalWriter} optionLabel="user_Name" optionValue="login_ID" placeholder="Select User" error={errors.AssignedTo?.message} />
            <div className="col-12 flex justify-content-end gap-2">
              <Button type="button" label="Clear" className="p-button-outlined" onClick={() => reset({ AssignedTo: 0 })} />
              <Button type="submit" label="Save" />
            </div>
          </div>
        </form>
      </Dialog>
    </>
  );
};

export default TenderAssigned;
